import React, { useEffect } from 'react';
import { Divider, Grid, Chip } from 'core/components/library';
import { Document, Combo, Switch, Select, Button } from 'core/components';
import Representantes from '../../../../../../entorno/Representantes';
import { ENTITY_CONTACTO } from 'store/entities/constants';
import * as icons from '../../../../../../core/icons';
import * as helpers from 'core/helpers';
import List from 'store/List';
import DetailRepresentante from 'views/entorno/contactos/Detalle';
import { DateTime } from 'luxon';
import Declaracion from '../../../Declaracion';
import * as enums from '../../../../../../core/enums';

const ComboRepsViticultor = List(Combo, 'options', 'lstrepsviticultor');
const ComboRepsBodega = List(Combo, 'options', 'lstrepresbodega');

const getAutorizadoPara = values => {
    if (values.tipo.clase === 'Declaracion') return ['Declaraciones', 'Todo'];

    if (values.tipo.clase === 'Solicitud') return ['Solicitudes', 'Todo'];

    return ['Todo'];
};

const Firmas = props => {
    const { values, editing, handleChange, refresh, auth } = props;

    return (
        <form autoComplete='off' noValidate>
            <Grid container spacing={2}>
                <Grid item xs={7}>
                    <Grid container direction='column' spacing={1}>
                        <Grid item xs>
                            <Divider style={{ margin: '12px 12px 12px 12px' }}>
                                <Chip label={'INTERESADO / REPRESENTANTE'} />
                            </Divider>
                        </Grid>
                        <Grid item xs>
                            <Grid container alignItems={'center'} spacing={1}>
                                <Grid item>
                                    {/*<Signature
                                        setImage={() => console.logsetImage}
                                    />*/}
                                </Grid>
                                <Grid item xs={3}>
                                    <Select
                                        fullWidth
                                        name='representaA'
                                        label='Representa a'
                                        value={values.representaA}
                                        onChange={handleChange}
                                        editing={editing}
                                        options={enums.typeRepresentative}
                                    />
                                </Grid>
                                {values.representaA && (
                                    <Grid item xs>
                                        {values.representaA === 'Viticultor'
                                            ? values.viticultor && (
                                                  <ComboRepsViticultor
                                                      fullWidth
                                                      api='contactos'
                                                      name='representante'
                                                      nameKey='representanteId'
                                                      label='Representante Viticultor'
                                                      relacionado={{
                                                          type: ENTITY_CONTACTO,
                                                          Detail: DetailRepresentante,
                                                          resume: ['nombre'],
                                                          readOnly: true
                                                      }}
                                                      refresh={refresh}
                                                      Icon={icons.ContactsIcon}
                                                      value={
                                                          values.representante
                                                      }
                                                      onChange={handleChange}
                                                      editing={editing}
                                                      propertyValue='id'
                                                      getOptionLabel={option =>
                                                          `${option.nombre}-[${option.nif}]-[${option.cargo}]`
                                                      }
                                                      searchKeys={[
                                                          'cargo',
                                                          'nombre',
                                                          'nif'
                                                      ]}
                                                      filters={[
                                                          {
                                                              fields: [
                                                                  [
                                                                      'viticultor',
                                                                      'id'
                                                                  ]
                                                              ],
                                                              values: [
                                                                  values
                                                                      .viticultor
                                                                      .id
                                                              ],
                                                              operator: 'in',
                                                              type: 'text'
                                                          },
                                                          {
                                                              fields: ['tipo'],
                                                              values: [
                                                                  'Autorizado',
                                                                  'Representante'
                                                              ],
                                                              operator: 'in',
                                                              type: 'text'
                                                          },
                                                          {
                                                              fields: [
                                                                  'autorizado'
                                                              ],
                                                              values: getAutorizadoPara(
                                                                  values
                                                              ),
                                                              operator: 'in',
                                                              type: 'text'
                                                          },
                                                          {
                                                              fields: [
                                                                  'activo'
                                                              ],
                                                              values: true,
                                                              operator: '',
                                                              type: 'boolean'
                                                          },
                                                          {
                                                              fields: ['hasta'],
                                                              values: DateTime.fromISO(
                                                                  values.fecha
                                                              ).toISODate(),
                                                              operator: '>=',
                                                              type: 'date'
                                                          }
                                                      ]}
                                                  />
                                              )
                                            : values.explotacion &&
                                              values.explotacion.bodega && (
                                                  <ComboRepsBodega
                                                      fullWidth
                                                      api='contactos'
                                                      name='representante'
                                                      nameKey='representanteId'
                                                      label='Representante Bodega'
                                                      relacionado={{
                                                          type: ENTITY_CONTACTO,
                                                          Detail: DetailRepresentante,
                                                          resume: ['nombre'],
                                                          readOnly: true
                                                      }}
                                                      refresh={refresh}
                                                      Icon={icons.ContactsIcon}
                                                      value={
                                                          values.representante
                                                      }
                                                      onChange={handleChange}
                                                      editing={editing}
                                                      propertyValue='id'
                                                      getOptionLabel={option =>
                                                          `${option.nombre}-[${option.nif}]-[${option.cargo}]`
                                                      }
                                                      searchKeys={[
                                                          'cargo',
                                                          'nombre',
                                                          'nif'
                                                      ]}
                                                      filters={[
                                                          {
                                                              fields: [
                                                                  [
                                                                      'bodega',
                                                                      'id'
                                                                  ]
                                                              ],
                                                              values: [
                                                                  values
                                                                      .explotacion
                                                                      .bodega.id
                                                              ],
                                                              operator: 'in',
                                                              type: 'text'
                                                          },
                                                          {
                                                              fields: ['tipo'],
                                                              values: [
                                                                  'Autorizado',
                                                                  'Representante'
                                                              ],
                                                              operator: 'in',
                                                              type: 'text'
                                                          },
                                                          {
                                                              fields: [
                                                                  'autorizado'
                                                              ],
                                                              values: getAutorizadoPara(
                                                                  values
                                                              ),
                                                              operator: 'in',
                                                              type: 'text'
                                                          },
                                                          {
                                                              fields: [
                                                                  'activo'
                                                              ],
                                                              values: true,
                                                              operator: '',
                                                              type: 'boolean'
                                                          },
                                                          {
                                                              fields: ['hasta'],
                                                              values: DateTime.fromISO(
                                                                  values.fecha
                                                              ).toISODate(),
                                                              operator: '>=',
                                                              type: 'date'
                                                          }
                                                      ]}
                                                  />
                                              )}
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                        <Grid item xs>
                            <Grid
                                container
                                justifyContent={'center'}
                                //alignItems={'center'}
                                gap={5}
                            >
                                <Grid item>
                                    <Grid
                                        direction={'column'}
                                        container
                                        //justifyContent={'center'}
                                        //alignItems={'center'}
                                        //gap={5}
                                    >
                                        <Grid item>
                                            <Switch
                                                value={values.excluirFirma}
                                                onChange={handleChange}
                                                name='excluirFirma'
                                                label='No Imprimir firma'
                                                editing={editing}
                                            />
                                        </Grid>
                                        {values.tipo && values.tipo.acta && (
                                            <Grid item>
                                                <Switch
                                                    value={values.firmaActa}
                                                    onChange={handleChange}
                                                    name='firmaActa'
                                                    label='Usar firma acta'
                                                    editing={editing}
                                                />
                                            </Grid>
                                        )}
                                        {!values.firmaActa && (
                                            <Grid item>
                                                <Button
                                                    toolTipText='Firma'
                                                    disabled={false}
                                                    onClick={event => {
                                                        window
                                                            .open(
                                                                `http://${window.location.hostname}/firma/?id=${values.id}&token=${auth.token}`,
                                                                '_blank',
                                                                'toolbar=no,scrollbars=no,resizable=no,top=500,left=500,width=520,height=500'
                                                            )
                                                            .addEventListener(
                                                                'close',
                                                                () =>
                                                                    console.log(
                                                                        'REFRECO'
                                                                    )
                                                            );
                                                    }}
                                                    counter={0}
                                                    busy={false}
                                                    icon={<icons.FirmaIcon />}
                                                    float={true}
                                                />
                                            </Grid>
                                        )}
                                    </Grid>
                                </Grid>

                                <Document
                                    //objectFit={'cover'}
                                    name='firma'
                                    readOnly={!editing || values.firmaActa}
                                    width='300px'
                                    height='200px'
                                    value={
                                        values.firmaActa
                                            ? values.actas &&
                                              values.actas.length > 0
                                                ? values.actas[
                                                      values.actas.length - 1
                                                  ].firma
                                                : null
                                            : values.firma
                                    }
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs>
                    <Representantes
                        name={'intervinientes'}
                        title={'REPRESENTANTES DOP'}
                        values={values}
                        editing={editing}
                        handleChange={handleChange}
                        refresh={refresh}
                    />
                </Grid>
            </Grid>
        </form>
    );
};

export default Firmas;
